exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tecnomap-zone-container .tecnomap-drawer .mapboxgl-map {\n  width: 100%;\n  height: 80vh;\n  background: #fff;\n  border-radius: 20px;\n  box-shadow: 0px 0px 11px 0px rgba(0, 0, 0, 0.16);\n}", ""]);

// exports
